var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VirtualGamesSidebarContainer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
var activeItem = ref.activeItem;
return _c('div',{},[(_vm.isSidebarExpanded)?_c('div',{staticClass:"modal__overlay",on:{"click":_vm.closeSidebar}}):_vm._e(),_vm._v(" "),_c('PrimaryNavItem',{attrs:{"selectedItem":activeItem,"isSidebarExpanded":_vm.isSidebarExpanded},on:{"click":_vm.toggleVirtualPageSidebar}})],1)}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610bcf88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/mobile/virtualGames/VirtualGamesSubNav.vue
// module id = 1429
// module chunks = 0